export const CONFIGURATION_VALUE_TYPE = Object.freeze({
    STRING: 0,
    INTEGER: 1,
    DOUBLE: 2,
    BOOLEAN: 3,
    ARRAY: 4,
    DATE: 5,
    DATE_TIME: 6,
    JSON: 7,
});
